module.exports = __webpack_public_path__ + "img/form_scheme_2.fd979ed8.png";